module.exports = __webpack_public_path__ + "img/kw.b1ecbcc7.svg";